module.exports = __webpack_public_path__ + "img/live-data-icon-2.70e98f83.svg";